import { useNavigate } from "react-router-dom";
import Table from "../../../Components/Tables/Table";
import PageHeader from "../../../Layout/PageHeader";
import { usePagination } from "../../../hooks/usePagination";
import { useEffect, useState } from "react";
import { ApiResponse } from "../../../model/common/apiResponse";
import { useSearchStore } from "../../../store/search/searchStore";
import Loader from "../../../Components/GlobalLoader/Loader";
import { fetchAllocationPlan } from "../Allocation/service/allocation.service";
import { AllocationListProps } from "../Allocation/model/AllocationList.type";

const AllocationList: React.FC<AllocationListProps> = ({
  pageName,
  headerName,
  columns,
  search_columns,
  db_columns,
  data: parentData,
  sorting_order,
  refreshTrigger,
}) => {
  const navigation = useNavigate();
  const { currentPage, handlePageChange, perPage } = usePagination();
  const [data, setData] = useState<ApiResponse<any> | null>(parentData || null);
  const { searchTerm, resetSearch, previousSearchTerm, setPreviousTerm } =
    useSearchStore();

  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    setData(null);
    if (searchTerm != previousSearchTerm && currentPage != 1) {
      handlePageChange(1);
    }

    let order: any[] = [];
    const payload: any = {
      columns: db_columns,
      limit: perPage,
      page: currentPage,
      search: searchTerm,
      order: sorting_order,
    };
    if (order.length > 0) {
      Object.assign(payload, { order });
    }
    console.log(search_columns, "search_columns");
    if (search_columns.length > 0) {
      Object.assign(payload, { search_columns });
    }

    fetchAllocationPlan(payload).then((response: any) => {
      setData(response ?? null);
      setPreviousTerm(searchTerm);
    });
  }, [currentPage, searchTerm, refreshTrigger]);

  return (
    <>
      {loading && <Loader />}
      {data ? (
        <>
          <PageHeader
            name={pageName}
            addUrl="/outbound/allocations/add"
            listUrl="/outbound/allocations"
          />
          <div className="clearfix"></div>
          <>
            <h5 className="text-start">{headerName}</h5>
            <div className="customerTableMainDiv">
              <Table
                columns={columns}
                data={data?.data?.results || []}
                pagination={{
                  recordsPerPage: perPage,
                  totalRecords: data?.data?.recordsTotal,
                  currentPage: currentPage,
                  onCurrentPageChange: handlePageChange,
                }}
                CheckboxStatus={false}
              />
            </div>
          </>
        </>
      ) : (
        <Loader />
      )}
    </>
  );
};
export default AllocationList;
